export default [
  {
    path: '/clockings',
    name: 'clockings',
    component: () => import('@/views/modules/clockings/export'),
    meta: {
      requiresAuth: true,
      layout: 'app',
      breadcrumb: [
        { text: 'Clockings', to: { name: "clockings" }  },
        { text: 'Clockings Export' }
      ]
    },
  }, 

  
]